import { useEffect }from 'react';
import { getSeoState } from './store/selectors/seoSelector';
import {useSelector} from 'react-redux'
const PageTitle = () => {
  const seoState = useSelector(getSeoState);
  const {
    gamePk,
    gameState,
    title,
    description,
    keywords
  } = seoState;

  useEffect(() => {
      if (typeof window !== 'undefined') {
        if (title) {
          document.title = title;
        }
        const descriptionMeta = document.querySelector('meta[name="description"]');
        const keywordsMeta = document.querySelector('meta[name="keywords"]');

        if (descriptionMeta && description) {
            descriptionMeta.setAttribute("content", description);
        }

        if (keywordsMeta && keywords) {
          keywordsMeta.setAttribute("content", keywords);
        }
      }
  }, [gamePk, gameState]);

  return null;
};

export default PageTitle;
